import React from 'react';

import DesignerProfile from '../../DesignerProfile';

const SummaryComponent = ({ designer, refetch }) => {
  return <DesignerProfile designer={designer} refetch={refetch} />;
};

export default SummaryComponent;
